<script>
import api from '@/repo/api'

export default {
    name: "WTaskItem",
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        status() {
            if (!this.item.white_image && !this.item.run_in_background) {
                return 'none';
            }
            return 'running';
        },
        statusText() {
            if (this.item.white_image) {
                return '已生成';
            }
            if (this.item.run_in_background) {
                return '生成中...';
            }
            return '';
        }
    },
    methods: {
        deleteItem() {
            this.$uniConfirm({
                title: '温馨提示',
                content: '删除后将无法恢复，是否继续？',
            }).then(([, result]) => {
                if (result.confirm) this.confirmDelete()
            })
        },
        async joinWardrobe() {
            
            if ((!this.item.white_image) && this.item.run_in_background) {
                
                let msg = this.item.error || '正在生成白底图，请耐心等待';
                
                this.$message.info(msg);
                
                return;
            }
            
            const res = await this.$uniConfirm({
                title: '温馨提示',
                content: '该图片还未生成AI白底图，是否继续上传衣橱'
            })
            
            if (!res[1].confirm) return;
            
            this.$emit('joinWardrobe', this.item);
        },
        async regenerateWhiteImage() {
            if (this.item.run_in_background && (!this.item.white_image)) {
                this.$message.info('正在生成中，请耐心等待');
                return;
            }
            await this.generateWhiteImage();
        },
        async generateWhiteImage() {
            this.$loading.show('请稍后..');
            
            try {
                // 接口前缀参考前文，推测为 /ast-wardrobe-job/...
                const result = await api.post('/ast-wardrobe-job/generate-white-image', {
                    id: this.item.id
                });
                
                this.$loading.hide();
                
                if (result.code !== 0) {
                    this.$message.error(result.msg || '操作失败');
                    return;
                }
                
                this.$message.success('操作成功');
                this.updateAttributes({run_in_background: 1, white_image: ''});
                
            } catch (error) {
                this.$loading.hide();
            }
        },
        updateAttributes(updateAttributes) {
            this.$emit('itemUpdate', this.item, updateAttributes);
        },
        async confirmDelete() {
            this.$loading.show('删除中...');
            
            try {
                const result = await api.post('/ast-wardrobe-job/del-job-image', {
                    id: this.item.id
                });
                
                this.$loading.hide();
                
                if (result.code !== 0) {
                    this.$message.error(result.msg || '删除失败');
                    return;
                }
                
                this.$message.success('删除成功');
                this.$emit('deleted', this.item);
                
            } catch (error) {
                this.$loading.hide();
            }
        },
    }
}
</script>

<template>
    <div class="wd-task-item">
        <div class="image-container">
            <div class="image-content">
                <div class="base-image">
                    <img class="image" :src="$imageThumbnail(item.image_url, 260)" style="object-fit: contain;">
                </div>
                <div class="image-status">
                    <div class="status-txt">{{ statusText }}</div>
                    <img v-if="status === 'none'" :src="$static('wd-task/icon_arrow_grey.png')">
                    <img v-else :src="$static('wd-task/icon_arrow_green.png')">
                </div>
                <div class="white-image">
                    <div v-if="!item.white_image && item.run_in_background" class="empty-image image running">
                        <img :src="$static('wd-task/icon_star.png')" style="object-fit: contain;">
                    </div>
                    <div v-else-if="!item.white_image" class="empty-image image">
                        <img :src="$static('wd-task/icon_photo.png')">
                    </div>
                    <div v-else class="true-white-image image">
                        <img :src="$imageThumbnail(item.white_image, 260)" style="object-fit: contain;">
                    </div>
                </div>
            </div>
        </div>
        <div class="wd-footer">
            <div class="wd-btn btn-1" @click="deleteItem">
                <img :src="$static('wd-task/icon_delete.png')">
                <span>删除</span>
            </div>
            <div class="wd-btn btn-2" v-if="status === 'none'" @click="generateWhiteImage">
                <img :src="$static('wd-task/icon_create.png')">
                <span>生成AI白底图</span>
            </div>
            <div class="wd-btn btn-2" v-else @click="regenerateWhiteImage">
                <img :src="$static('wd-task/icon_regenerate.png')">
                <span>重新生成</span>
            </div>
            <div class="wd-btn btn-3" @click="joinWardrobe">
                <img :src="$static('wd-task/icon_import.png')">
                <span>导入衣橱</span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
/* 按 2rpx = 1px 的比例转换了所有的数值 */
.wd-task-item {
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 10px;
    border: 1px solid #EDEDED;
}

.image-container {
    padding-left: 15px;
    padding-right: 15px;
    height: 101px;
}

.image-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    height: 100%;
    border-bottom: 1px dashed #DDDDDD;
    
    .image {
        width: 65px;
        height: 65px;
        background: #F7F7F7;
        border-radius: 8px;
    }
}

.base-image {
    padding-left: 30px;
}

.white-image {
    padding-right: 30px;
    
    .true-white-image img {
        width: 65px;
        height: 65px;
    }
    
    .empty-image {
        display: flex;
        justify-content: center;
        align-items: center;
        
        img {
            width: 20px;
            height: 20px;
        }
        
        &.running {
            background: radial-gradient(0% 0% at 0% 0%, #EEFAF3 12.4%, #F4FDFC 49.02%, #E1F7F4 89.58%);
            
            img {
                width: 15px;
                height: 15px;
            }
        }
    }
}

.image-status {
    font-weight: 400;
    font-size: 10px;
    color: #67C19B;
    text-align: center;
    
    .status-txt {
        margin-bottom: 3px;
    }
    
    img {
        width: 70px;
        height: 7px;
    }
}

.wd-footer {
    height: 40px;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding-left: 15px;
    padding-right: 15px;
    font-size: 13px;
    color: #666666;
    
    .wd-btn {
        display: flex;
        align-items: center;
        cursor: pointer; /* Web端增加鼠标手势，提升体验 */
    }
    
    .btn-1 {
        color: #ADADAD;
    }
    
    .btn-2 {
        margin-left: auto;
    }
    
    .btn-3 {
        margin-left: 21px;
    }
    
    img {
        width: 15px;
        height: 15px;
        margin-right: 4px;
    }
}
</style>